import { typeahead } from "@mirage/service-typeahead-search/service/types";

import type { TypeaheadResult } from "@mirage/mosaics/SearchBarWithTypeahead/useConvertToTypeaheadResults";
import { getIsLauncher } from "@mirage/service-experimentation/useDualMode";

export function getAddToStackParams(
  scoredResult: typeahead.ScoredResult,
): { url: string; title: string } | undefined {
  const { type, result } = scoredResult;

  if (!("url" in result) || !result.url) {
    return undefined;
  }

  if (type === typeahead.ResultType.StackItem) {
    return { url: result.url, title: result.name };
  }

  if (
    type === typeahead.ResultType.SearchResult ||
    type === typeahead.ResultType.Recommendation
  ) {
    return { url: result.url, title: result.title };
  }

  return undefined;
}

export function showAddToStackShortcut(result?: TypeaheadResult) {
  if (!result) return false;
  return (
    result.type === typeahead.ResultType.StackItem ||
    result.type === typeahead.ResultType.SearchResult ||
    result.type === typeahead.ResultType.Recommendation
  );
}

export function showSummarizeShortcut(
  result?: TypeaheadResult,
): result is TypeaheadResult & { summarizable: "yes_summarizable" } {
  // disabling in the launcher in dual mode on desktop for now see OSF-1615
  if (!result || getIsLauncher()) return false;
  return result.summarizable === "yes_summarizable";
}

export function showCopyLinkShortcut(
  isOmniboxEnabled: boolean,
  result?: TypeaheadResult,
) {
  if (!result) return true;

  // Previous logic before we introduced omnibox
  if (!isOmniboxEnabled) return true;

  return result.type === typeahead.ResultType.Recommendation;
}

export function showNewShortcut(
  isOmniboxEnabled: boolean,
  omniboxScopedMode?: string,
) {
  // Previous logic before we introduced omnibox
  if (!isOmniboxEnabled) {
    return true;
  }

  return omniboxScopedMode === typeahead.Mode.Default;
}
